/* ==========================================================================
   RaoOfficialStore — Theme behaviour
   Carousels, accordions, quantity steppers, product variant selection,
   and add-to-cart wired into Dawn's <cart-drawer>.
   Vanilla JS, event-delegated, resilient to sections re-rendering.
   ========================================================================== */
(function () {
  'use strict';

  var money = window.Shopify && window.Shopify.formatMoney;
  function fmtMoney(cents, format) {
    if (money) return money(cents, format || (window.RFW && window.RFW.moneyFormat));
    return 'Rs ' + (cents / 100).toLocaleString('en-PK');
  }

  /* ---------- Carousels ---------- */
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-rfw-scroll]');
    if (!nav) return;
    var wrap = nav.closest('[data-rfw-carousel]') || document;
    var rail = wrap.querySelector('[data-rfw-rail]');
    if (!rail) return;
    var dir = nav.getAttribute('data-rfw-scroll') === 'prev' ? -1 : 1;
    rail.scrollBy({ left: dir * Math.max(280, rail.clientWidth * 0.8), behavior: 'smooth' });
  });

  /* ---------- Open cart drawer (header bag button) ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-rfw-cart-open]');
    if (!opener) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return; /* no drawer → let the link fall through to /cart */
    if (typeof drawer.open === 'function') {
      e.preventDefault();
      drawer.open(opener);
    } else if (window.RFW && window.RFW.loadLazy && window.customElements) {
      /* drawer JS is lazy-loaded on this page: load it, then open */
      e.preventDefault();
      window.RFW.loadLazy()
        .then(function () { return customElements.whenDefined('cart-drawer'); })
        .then(function () { drawer.open(opener); })
        .catch(function () { window.location.href = opener.getAttribute('href') || '/cart'; });
    }
  });

  /* ---------- Accordion ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rfw-acc__btn');
    if (!btn) return;
    var item = btn.closest('.rfw-acc__item');
    if (!item) return;
    var acc = item.closest('.rfw-acc');
    var single = acc && acc.hasAttribute('data-rfw-single');
    if (single && !item.classList.contains('is-open')) {
      acc.querySelectorAll('.rfw-acc__item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
    }
    item.classList.toggle('is-open');
  });

  /* ---------- Standalone quantity steppers (data-rfw-qty) ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-rfw-qty-step]');
    if (!step) return;
    var box = step.closest('[data-rfw-qty]');
    if (!box) return;
    var input = box.querySelector('input, [data-rfw-qty-val]');
    var val = parseInt((input && (input.value || input.textContent)) || '1', 10) || 1;
    var min = parseInt(box.getAttribute('data-min') || '1', 10);
    var max = parseInt(box.getAttribute('data-max') || '9999', 10);
    val += step.getAttribute('data-rfw-qty-step') === 'down' ? -1 : 1;
    val = Math.min(max, Math.max(min, val));
    if (input) { if ('value' in input) input.value = val; else input.textContent = val; }
    var valEl = box.querySelector('[data-rfw-qty-val]');
    if (valEl && valEl !== input) valEl.textContent = val;
    box.querySelectorAll('[data-rfw-qty-step="down"]').forEach(function (b) { b.disabled = val <= min; });
    box.querySelectorAll('[data-rfw-qty-step="up"]').forEach(function (b) { b.disabled = val >= max; });
  });

  /* ---------- Product variant selection ---------- */
  function ProductForm(root) {
    this.root = root;
    var data = root.querySelector('[data-rfw-variants]');
    try { this.variants = data ? JSON.parse(data.textContent) : []; } catch (_) { this.variants = []; }
    this.idInput = root.querySelector('[data-rfw-variant-id]');
    this.priceEl = root.querySelector('[data-rfw-price]');
    this.stockEl = root.querySelector('[data-rfw-stock]');
    this.addBtn = root.querySelector('[data-rfw-add]');
    this.addLabel = this.addBtn ? this.addBtn.querySelector('[data-rfw-add-label]') : null;
    this.bind();
    this.update();
  }
  ProductForm.prototype.selectedOptions = function () {
    var opts = [];
    this.root.querySelectorAll('[data-rfw-option]').forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-rfw-option'), 10) - 1;
      var chosen = group.querySelector('.is-selected, :checked');
      var val = chosen ? (chosen.getAttribute('data-value') || chosen.value) : null;
      opts[pos] = val;
    });
    return opts;
  };
  ProductForm.prototype.matchVariant = function (opts) {
    return this.variants.find(function (v) {
      return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
    });
  };
  ProductForm.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-rfw-option] [data-value]');
      if (!opt || opt.disabled) return;
      var group = opt.closest('[data-rfw-option]');
      group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-selected'); });
      opt.classList.add('is-selected');
      var nameEl = group.querySelector('[data-rfw-option-current]');
      if (nameEl) nameEl.textContent = opt.getAttribute('data-value');
      self.update();
    });
    this.root.addEventListener('change', function (e) {
      if (e.target.matches('[data-rfw-option] select, [data-rfw-option] input')) self.update();
    });
  };
  ProductForm.prototype.update = function () {
    var v = this.matchVariant(this.selectedOptions());
    if (this.idInput && v) this.idInput.value = v.id;
    if (this.priceEl && v) {
      var html = '<span class="rfw-price__value">' + fmtMoney(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<span class="rfw-price__was">' + fmtMoney(v.compare_at_price) + '</span>';
        this.priceEl.classList.add('is-sale');
      } else { this.priceEl.classList.remove('is-sale'); }
      this.priceEl.innerHTML = html;
    }
    if (this.stockEl && v) {
      if (v.available) {
        var q = v.inventory_quantity;
        this.stockEl.textContent = (q && q > 0 && q <= 10) ? ('Only ' + q + ' left in this size') : 'In stock · ready to ship';
      } else { this.stockEl.textContent = 'Sold out in this size'; }
    }
    if (this.addBtn) {
      var ok = v && v.available;
      this.addBtn.disabled = !ok;
      this.addBtn.classList.toggle('is-disabled', !ok);
      if (this.addLabel) this.addLabel.textContent = !v ? 'Select options' : (v.available ? 'Add to bag' : 'Sold out');
    }
  };

  /* ---------- Add to cart → Dawn cart drawer ---------- */
  function handleAdd(form, opts) {
    opts = opts || {};
    var drawer = document.querySelector('cart-drawer');
    var body = new FormData(form);
    var config = { method: 'POST', headers: { Accept: 'application/javascript' }, body: body };
    var sectionsRequested = false;
    if (drawer && !opts.checkout) {
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
      sectionsRequested = true;
    }
    var btn = form.querySelector('[data-rfw-add]');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', config)
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || 'Could not add to bag'); return; }
        refreshCount();
        if (opts.checkout) {
          window.location.href = '/checkout';
          return;
        }
        if (drawer && sectionsRequested && res.sections) {
          if (typeof drawer.renderContents === 'function') {
            drawer.renderContents(res);
          } else if (window.RFW && window.RFW.loadLazy) {
            window.RFW.loadLazy()
              .then(function () { return customElements.whenDefined('cart-drawer'); })
              .then(function () { drawer.renderContents(res); });
          }
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        toast('Added to your bag');
      })
      .catch(function () { toast('Network error — try again'); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-rfw-cart-form]');
    if (!form) return;
    e.preventDefault();
    handleAdd(form);
  });
  document.addEventListener('click', function (e) {
    var buy = e.target.closest('[data-rfw-buynow]');
    if (!buy) return;
    var form = buy.closest('form[data-rfw-cart-form]');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[data-rfw-variant-id]');
    if (idInput && !idInput.value) { toast('Select your options first'); return; }
    handleAdd(form, { checkout: true });
  });

  /* ---------- Product gallery (thumbnail swap) ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-rfw-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-rfw-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-rfw-main] img') || gallery.querySelector('[data-rfw-main]');
    var src = thumb.getAttribute('data-rfw-thumb');
    if (main && src) {
      if (main.tagName === 'IMG') { main.src = src; main.srcset = ''; }
    }
    gallery.querySelectorAll('[data-rfw-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  function refreshCount() {
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-rfw-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      }).catch(function () {});
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('rfw-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'rfw-toast';
      document.body.appendChild(t);
    }
    t.innerHTML = '<svg class="rfw-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg><span>' + msg + '</span>';
    t.className = 'is-visible';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.className = ''; }, 2600);
  }
  window.RFWtoast = toast;

  /* ---------- Init ---------- */
  function init() {
    document.querySelectorAll('[data-rfw-product]').forEach(function (root) {
      if (!root.__rfwInit) { root.__rfwInit = true; new ProductForm(root); }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
